import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import dateFormatReverse from 'constants/dateformatReverse';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
import useLatLng from 'hooks/uselatlng/uselatlng';
import GoogleMapReact from 'google-map-react';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import 'pages/attendance/attendanceDetails/attStyle.css';
import {toast } from "react-toastify";
import CardSection from 'components/sales/cardSection/cardSection';
import "./meetingform.css";
import DatePicker from 'components/sales/datePicker/datePicker';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import {
  SALES_SUB_SUBJECT_OPTIONS,
  isSalesMeetingAgenda,
} from '../meetingSalesSubSubject';

const MeetingFormSchedule = ({
  handleValue,
  pocList,
  documentUploadUrl,
  siteId,
  meetingById = null,
  teamId,
  corpClientList,
  getCorpPocList,
  corpClientPoc,
  viewMeeting,
  getInvoiceList,
  invoiceList,
  documentUrlDataPublic,
  documentUploadUrlPublic,
  setIsLoading,
  getCorpClientList,
  getBaOpportunityFromLeadx=() => {},
  opportunityLis=[],
  manageId
}) => {
  const inputs = {
    site_id: '',
    poc: '',
    others_email: '',
    scheduled_date: '',
    scheduled_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    subject: '',
    sub_subject: '',
    status: 1,
    body: '',
    client_id: '',
    client_category: 1,
    client: 'NA',
    remark:'',
    attachment : '',
    paymentPicked: '',
    paymentMode:'',
    chequeRemark: '',
    opportunity:[],
    saleType:'',
    manage_id:manageId,
  };
  const [inputIteration, setInputIteration] = useState([{invoice_number:'',cheque_trnx_no:'',cheque_trnx_date:'',bank:'',amount:'',document:'',invoice_name:'',tds_amount:''}]);
  const [formData, setData] = useState(inputs);
  const [pocsList, setPocsList] = useState([]);
  const [isFocus, setIsFocus] = useState(false);
  const [othersEmail, setOthersEmail] = useState('');
  const islatlng = useLatLng();
  const [mapLocation, setMapLocation] = useState({
    address: 'Delhi',
    lat: 0,
    lng: 0,
  });
  const [isAllow, setIsAllow] = useState(false);
  const [selectSiteId, setSelectSiteId] = useState(0);
  const [opportunity, setOpportunity] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [meetingDistance, setMeetingDistance] = useState('');
  const [scheduleDate, setScheduleDate] = useState('');

  const handleDateHide = () => {
    if (formData.scheduled_date) {
      setIsFocus(true);
    }
  };
  console.log(corpClientList);
 
  useEffect(() => {
       if(corpClientList?.distanceFromSite !== null && corpClientList?.distanceFromSite !== undefined) {
         setMeetingDistance(corpClientList?.distanceFromSite);
       }
  },[corpClientList?.distanceFromSite]);

  useEffect(() => {
    if(corpClientList?.meeting_plan_data !== null && corpClientList?.meeting_plan_data !== undefined) {
      const str = corpClientList?.meeting_plan_data?.agenda;
      const meeting_date = corpClientList?.meeting_plan_data?.plan_date;
      if(meeting_date) {
        setScheduleDate(meeting_date);
      }
      setData({ ...formData, subject: str });
    }
  },[corpClientList?.meeting_plan_data]);

  useEffect(() => {
     if(scheduleDate !== '' && scheduleDate != undefined) {
        setData({ ...formData, scheduled_date: scheduleDate });
     }
  },[scheduleDate]);

  console.log(formData);


  /* useEffect(() => {
    if (Object.values(viewMeeting).length) {
      setOthersEmail(viewMeeting?.others_email.join(', '));
      setData({
        ...formData,
        others_email: viewMeeting?.others_email.join(', '),
      });
    }
  }, [viewMeeting]); */

  // useEffect(() => {
  //   (async () => {
  //     if (
  //       teamId === 'Corporate' &&
  //       formData.client_category === 2 &&
  //       formData.client_id !== ''
  //     ) {
  //       await getCorpPocList(formData.client_id);
  //     }
  //   })();
  // }, [teamId, formData, getCorpPocList]);

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
      
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if(!isNaN(lati) && !isNaN(langi)){
      setMapLocation({
        address: 'Delhi6',
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
   
  }, [islatlng]);

  useEffect( () => {
      (async ()=> {
          if(parseInt(selectSiteId) !== 0 && selectSiteId !== '') {
              await getBaOpportunityFromLeadx(selectSiteId)
          }
      })()
  }, [selectSiteId])

  useEffect(() => {
    if (meetingById !== null) {
      if (meetingById?.poc?.length > 0) {
        const pocIds =
          meetingById?.poc?.length > 0 && meetingById.poc.map((ele) => ele.id);
        setData({
          ...formData,
          poc: pocIds ? pocIds : '',
        });
        setPocsList(meetingById?.poc);
      }
      setData({
        ...formData,
        subject: meetingById?.meeting?.subject,
        body: meetingById?.meeting?.body,
        scheduled_date:
          (meetingById?.meeting?.scheduled_date &&
            dateFormatReverse(meetingById?.meeting?.scheduled_date)) ||
          new Date(),
      });
      setIsFocus(true);
    }
  }, [meetingById]);

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, scheduled_date: dateString });
  };
  const handleChequeDateChange = (date, dateString) => {
    setData({ ...formData, chequeDate: dateString });
  };

  const handleMeetingData = () => {
      if (isAllow) {
      alert(localization.locationPermission);
      return false;
    }
    if (
      // formData?.poc?.length > 0 &&
      formData.site_id !== '' &&
      formData.subject !== '' &&
      formData.body !== '' &&
      isAllow === false
    ) {
      /*if (formData.subject === 'Payment Collection Meeting') {
        if (
          formData.chequeNo === '' ||
          formData.chequeAmt === '' ||
          formData.chequeDate === '' ||
          formData.chequePhoto === ''
        ) {
          toast.error('Please fill all cheque details along with attachment!');
          handleValue(null); return;
        }
      }*/
      //console.log('ii' + JSON.stringify(inputIteration));
        const upsellingOpportunity = [];
        // eslint-disable-next-line array-callback-return
        opportunity.map( (val, index) => {
            upsellingOpportunity[index] = val.name
        })

      meetingById !== null && meetingById?.meeting?.id
        ? handleValue({
            ...formData,
            id: meetingById?.meeting?.id,
            lat: islatlng?.lat,
            lng: islatlng?.lng,
            opportunity:upsellingOpportunity,
            inputIteration
          })
        : handleValue({ ...formData,
          lat: islatlng?.lat,
          lng: islatlng?.lng,
          opportunity:upsellingOpportunity,
          inputIteration
        });
    } else handleValue(null);
  };
  useEffect(() => {
    if (
      formData.site_id !== '' &&
      formData.subject !== '' &&
      formData.body !== ''
    ) {
      handleMeetingData();
    }
  }, [formData, inputIteration]);

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, scheduled_time: `${hour}:${minute}` });
  }
  function renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      },
      map,
      title: 'You are here!'
    });
  } 

  const handleValues = (val,key,index) => { //console.log(val);
    var flag = true;
    if(key === 'invoice_number') {
      inputIteration.map((value,i) => {
        console.log(value['invoice_number'] + ' ' + val.id);
         if(value['invoice_number'] && (value['invoice_number'] === val.id)) {
             toast.error('This invoice is aleady selected. Please choose another.');
             flag = false;
             return false;
         }
      });
    }
    //console.log(val + key + index);
    const list = [...inputIteration];
    if(key === 'invoice_number') {
      list[index][key] = (flag == true) ? val.id : '';
      list[index]['invoice_name'] = (flag == true) ? val.name : '';
    } else {   
      list[index][key] = val;
    }

    console.log(list); 
    setInputIteration([...list]);
  };

  const handleRemoveClick = index => {
    const list = [...inputIteration];
    list.splice(index, 1);
    setInputIteration(list);
  };

  const handleAddClick = () => {
    setInputIteration([...inputIteration, {invoice_number:'',cheque_trnx_no:'',cheque_trnx_date:'',bank:'',amount:'',document:'',invoice_name:'',tds_amount:''}]);
  };

  const getInvoicesAgainstSite = async (siteId) => {
      if(siteId != "" && siteId != undefined) {
           //console.log('Site Id ' + siteId);
           const invoices = getInvoiceList(siteId);
      } 
  }
   useEffect(() => {
     if(siteId !== undefined) {
      getInvoiceList(siteId, 'INVOICE');
      getBaOpportunityFromLeadx(siteId);
      setData({ ...formData, site_id: siteId });
     }
   },[siteId]);

   useEffect(() => {
      if(invoiceList !== undefined && invoiceList != '' && invoiceList != null) {
        setInvoiceData(invoiceList);
      }
   },[invoiceList]);

  const applySearchKey = async (tranxNo,key,index) => {
    if(tranxNo && tranxNo != '') {
      const url = `${Config.brandActivation.getTransactionAmountFromUncliamed}?transaction_id=${tranxNo}`;
      const { data } = await axios.get(url);
      if(data && data.response.data) {
         var amount = '';
         if(data.response.data.resultSets && data.response.data.resultSets[0]) {
            amount = data.response.data.resultSets[0].transaction_amount;
            toast.success('Amount fetched successfully.');
         } else {
            toast.info('No transaction found.');
         }
         const list = [...inputIteration]; 
         list[index][key] = amount;
         setInputIteration([...list]);
      }
    }
  }
  //console.log('Invoices' + JSON.stringify(invoiceList));

  return (
    <CardSection title={localization.meetingDetails}>
     <div className='row'>
     <div className='col-md-12'>
     <div className="panel-heading messageBox"><div>
         Lat. : {mapLocation?.lat}
        &nbsp; Long. :  {mapLocation?.lng}
          </div>
          <span>(Distance between site and current location : <b>{meetingDistance}</b> meter)</span>
          </div>
      </div>
     
        {/* {corpClientList && corpClientList.sites ? 
          <div className='col-md-6'>
            <DropDownInput
            data={corpClientList.sites}
            label={localization.clientName}
            required
            getIdValue={(val) => {
              setData({
                ...formData,
                site_id: val.id,
              });
                setSelectSiteId(val.id)
                getInvoicesAgainstSite(val.id);
            }}
            errorMsg={localization.requiredName}
            isStarRequired={true}
          />
          </div>
        : null} */}
      {/* <div className='col-md-6'>
      <FormGroup
        className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      >
        <DatePickerInput
          value={formData.scheduled_date}
          onChange={handleDateChange}
          onShow={() => setIsFocus(true)}
          onHide={handleDateHide}
          onClear={() => setIsFocus(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          maxDate={new Date()}
        />
        <label>
          {localization.selectDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>
      </div> */}
      <div className='col-md-6'>
      <FormGroup>
        <TimePicker
          theme="classic"
          timeFormat="HH:MM"
          timeMode={24}
          time={formData?.scheduled_time}
          onTimeChange={onChange}
        />
        <label>{localization.selectTime}</label>
        <label className="error date_error">{localization.isRequired}</label>
      </FormGroup>
      </div>

      <div className='col-md-6'>
      {corpClientList && corpClientList.agenda ? 
            <DropDownInput
            data={corpClientList.agenda}
            label={localization.meetingAgenda}
            required
            errorMsg={localization.meetingAgenda}
            getIdValue={(val) => {
              setData({
                ...formData,
                subject: val.id,
                paymentPicked: '',
                sub_subject: isSalesMeetingAgenda(val?.id)
                  ? formData.sub_subject
                  : '',
              });
            }}
            isStarRequired={true}
            value={formData?.subject}
            disabled={true}
          />
        : 
            null
        }
      </div>

      {isSalesMeetingAgenda(formData.subject) && (
        <div className="col-md-6">
          <DropDownInput
            data={SALES_SUB_SUBJECT_OPTIONS}
            label={localization.subMeetingAgenda}
            getIdValue={(val) =>
              setData({ ...formData, sub_subject: val?.id ?? '' })
            }
            value={formData?.sub_subject}
          />
        </div>
      )}

      {formData.subject === "Upselling" &&
       <div className='col-md-6'>
          <DropDownInput
              data={opportunityLis}
              label={localization.opportunity}
              required={true}
              errorMsg={localization.opportunity}
              getIdValue={(val) => {
                  setOpportunity(val)
              }}
              isStarRequired={true}
              multipule={true}
          />
       </div>
      }
      <div className='col-md-6'>
      {formData && (formData.subject === 'Payment Collection Meeting' || formData.subject === 'payment collection meeting') &&
        <DropDownInput
          data={[
            {id: 'Yes', name: 'Yes'},
            {id: 'No', name: 'No'}
          ]}
          label={localization.paymentPicked}
          required
          errorMsg={localization.paymentPicked}
          getIdValue={(val) => {
            setData({
              ...formData,
              paymentPicked: val.id,
            });
          }}
          isStarRequired={true}
        />
      }
      </div>
      <div className='col-md-6'>
      {formData && formData.paymentPicked === 'Yes' ?
        <>
        <DropDownInput
          label={localization.saleTypeHeading}
          data={[
            { id: "Collection against invoice", name: "Collection against invoice" },
            { id: "New Sale", name: "New Sale" },
          ]}
          required
          errorMsg={localization.saleTypeHeading}
          getIdValue={(val) => {
            setData({
              ...formData,
              saleType: val.id,
            });
          }}

          isStarRequired={true}
        />
        </>
        :
        null
      }
      </div>
      <div className='col-md-6'>
      {formData && formData.paymentPicked === 'Yes' && formData.saleType != '' ?
        <>
        <DropDownInput
          label={localization.paymentMode}
          data={[
            { id: "Cash", name: "Cash" },
            { id: "Cheque", name: "Cheque" },
            { id: "NEFT", name: "NEFT" },
            { id: "IMPS", name: "IMPS" },
            { id: "RTGS", name: "RTGS" },
            { id: "UPI", name: "UPI" },
            { id: "NACH", name: "NACH" },
            { id: "PDC_CHEQUE", name: "PDC_CHEQUE" },
          ]}
          required
          errorMsg={localization.paymentMode}
          getIdValue={(val) => {
            setData({
              ...formData,
              paymentMode: val.id,
            });
          }}

          isStarRequired={true}
        />
        </>
        :
        null
      }
      </div>
      {formData && formData.paymentPicked === 'Yes' && formData.paymentMode != '' ?
        <>
        {inputIteration.map((x, i) => {
         return (
          <div className='col-md-12 row dd-cl' key={i+1}>
          {formData.saleType != '' && formData.saleType != 'New Sale' &&
            <div className='col-md-6'>
              <DropDownInput
                data={invoiceData}
                label={localization.invoice}
                required
                errorMsg={localization.invoice}
                getIdValue={(val) => {
                  handleValues(val,'invoice_number',i)
                }}
                value={x?.invoice_name ?? null}
                isStarRequired={true}
              />
            </div>
          }

          <div className='col-md-6 d-inline-flex'>
          <ConstantInput
            value={x.cheque_trnx_no}
            label={formData.paymentMode === 'Cheque' ? localization.chequeNo : localization.trnxNo}
            errorMsg={localization.chequeNo}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => handleValues(value,'cheque_trnx_no',i)}
          />
          {formData.paymentMode != 'Cheque' && formData.paymentMode != 'Cash' &&
            <div>
              <button type="button" className="btn btn-outline-primary btn-primary colorBox borderColorBox" onClick={() => applySearchKey(x.cheque_trnx_no,'amount',i)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
              </svg>
              </button>
            </div>  
          }
          </div>

        <div className='col-md-6'>
          <ConstantInput
            value={x.amount}
            label={formData.paymentMode === 'Cheque' ? localization.chequeAmt : localization.trnxAmt}
            errorMsg={localization.chequeAmt}
            type="number"
            required
            isStarRequired={true}
            handleChange={(value) => handleValues(value,'amount',i)}
          />
          </div>
          <div className='col-md-6'>
          <ConstantInput
            value={x.tds_amount}
            label={localization.tdsAmount}
            errorMsg={localization.tdsAmount}
            type="number"
            required
            isStarRequired={true}
            handleChange={(value) => handleValues(value,'tds_amount',i)}
          />
          </div>
          <div className='col-md-6'>
          <DropDownInput
            data={[
                    {
                      id: "HDFC",
                      name: "HDFC",
                    },
                    {
                      id: "IDFC",
                      name: "IDFC",
                    },
                    {
                      id: "ICICI",
                      name: "ICICI",
                    },
                    {
                      id: "IDBI",
                      name: "IDBI",
                    },
                    {
                      id: "STANDARD_CHARTERED",
                      name: "STANDARD_CHARTERED",
                    },
                  ]}
            label={localization.bankName}
            required
            errorMsg={localization.bankName}
            getIdValue={(val) => {
              handleValues(val.id,'bank',i)
            }}
            value={x.bank}
            isStarRequired={true}
          />
          </div>
          <div className='col-md-6'>
          <FormGroup
            className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
          >
          <DatePicker
            handleChange={(val) =>
              handleValues(val,"cheque_trnx_date", i)
            }
            label={localization.transactionDate}
            required={false}
            value={x?.cheque_trnx_date}
          />
          </FormGroup>
          </div> 

          <div className="col-md-4" key={i+1}>
            <FileUpload
              id={`document${i}`}
              accept=".pdf,.png,.jpg,.jpeg,.doc"
              documentUploadUrl={documentUploadUrlPublic}
              documentUrlData={documentUrlDataPublic}
              onChange={(val) =>
                handleValues(val,"document", i)
              }
            >
            <span className="btn btn-transparent">
              {localization.document}
            </span>
            </FileUpload>
          </div>
          <div className="col-md-3 col-sm-12 d-flex">
              {inputIteration.length !== 1 && 
                <div className="col-md-2 col-sm-5">
                    <button
                    onClick={() => handleRemoveClick(i)} 
                    className="mr10 btn btn-sm btn-danger">Remove</button>
                    </div>
                    }
                    {inputIteration.length - 1 === i && 
                    <div className="col-md-2 col-sm-5">
                    <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>
                </div>
              }
            </div>
          </div>
          );
        })}
        </>
      :null}  
      <div className='col-md-6'>
      {formData && formData.paymentPicked === 'No' &&
        <ConstantInput
          value={formData.chequeRemark}
          label={localization.chequeReason}
          errorMsg={localization.chequeReason}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => setData({ ...formData, chequeRemark: value })}
        />
      }
         {formData && formData.subject === 'Other' ? 
            <ConstantInput
            value={formData.remark}
            label={localization.enterSubject}
            errorMsg={localization.enterSubject}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => setData({ ...formData, remark: value })}
            />
          :
            null
          }
      </div>
      
      <div className='col-md-12'>
      <TextAreaInput
        inputValue={formData?.body}
        className={`${!formData.body && 'empty'} inline-css scrollbar-styling`}
        rows={4}
        type="text"
        label={localization.meetingDescription}
        required
        isStarRequired={true}
        errorMsg={localization.isRequired}
        handleChange={(e) => setData({ ...formData, body: e.target.value })}
      />
      </div>
      <div className="col-md-6 col-sm-12">
          <FileUpload
            id="attactment"
            multiple="multiple"
            // reset={successModal}
            accept=".pdf,.png,.jpg,.jpeg,.doc"
            documentUploadUrl={documentUploadUrl}
            onChange={(val) =>
              setData({ ...formData, attachment: val })
            }
          >
            <span className="btn btn-transparent">
              {localization.uploadMultiAttachment}
            </span>
          </FileUpload>
        </div>
      <div className="map">
           {/* {console.log(mapLocation)} */}
            <div className="google-map">
             {/* {(mapLocation && mapLocation.lat &&
              <GoogleMapReact
              bootstrapURLKeys={{ key: 'AIzaSyCweWEGenU5sDidT_1MKho5VoAhMC4CgtQ' }}
              defaultCenter={mapLocation}
              defaultZoom={15}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}
            >
            </GoogleMapReact>
             )}             */}
              
            </div>
          </div>
          <br/> 
          </div>
    </CardSection>
  );
};

MeetingFormSchedule.propTypes = {};

export default MeetingFormSchedule;
